import { getFormattedProduct } from "@repo/lib/helpers";
import { useFeatureFlag } from "@repo/lib/hooks/common";
import { useCallback } from "react";

const useTrackRemoveFromWishlist = () => {
  const isWebEngageEnabled = useFeatureFlag("webEngage");
  const trackRemoveFromWishlistEvent = useCallback(
    (product) => {
      if (!isWebEngageEnabled) {
        console.warn("WebEngage feature is disabled");
        return;
      }
      if (window.webengage) {
        if (product) {
          window.webengage.track(
            "remove_from_wishlist",
            getFormattedProduct(product)
          );
        }
      } else {
        console.error("WebEngage is not defined");
      }
    },
    [isWebEngageEnabled]
  );

  return { trackRemoveFromWishlistEvent };
};

export default useTrackRemoveFromWishlist;
